import { useEffect, useState } from "react"
import { InputModel } from "../../../../../../../utils/types"

const useInput = () =>{
    const [input, setInput] = useState<{ [x: string]: InputModel }>({
        nameCategory: {
            label: 'catalog.inputs.category',
            translate: true,
            name: 'nameCategory',
            type: 'text',
            validate: {
              required: true,
            },
            customeErrors: {
              required: 'catalog.form.crud.categoryName',
            },
            rest: {
              type: 'alphaNumeric',
              inputProps: {
                maxLength: 500,
              },
            },
            value: null,
            size: {
              lg: 12,
              md: 12,
              sm: 12,
              xl: 12,
              xs: 12
            }
        },
    })


    const [inputFilter, setInputFilter] = useState<{ [x: string]: InputModel }>({
      search: {
        label: 'catalog.inputs.searchCatalog',
        translate: true,
        name: 'search',
        rest: {
          type: 'alphaNumeric',
        },
        value: null,
      },
  })

  const [inputCrud, setInputCrud] = useState<{ [x: string]: InputModel }>({
    catalogName: {
      label: 'catalog.inputs.catalogName',
      translate: true,
      name: 'catalogName',
      type: 'text',
      validate: {
        required: true,
      },
      customeErrors: {
        required: 'catalog.form.crud.catalogName',
      },
      rest: {
        type: 'alphaNumeric',
        inputProps: {
          maxLength: 500,
        },
      },
      value: null,
      size: {
        lg: 12,
        md: 12,
        sm: 12,
        xl: 12,
        xs: 12
      }
    },
})

    return {input,inputFilter,inputCrud}
}


export { useInput }